import React from 'react';
import PropTypes from 'prop-types';

const Image = props => {
  const image = (
    <img
      src={props.src}
      id={props.id}
      className={props.className}
      role={props.role}
      alt={props.alt}
      onError={props.defaultImgSrc}
      loading={props.loading}
    />
  );

  if (props.onClick) {
    return (
      <button type="button" className="vve-image-button" onClick={props.onClick}>
        {image}
      </button>
    );
  }

  return image;
};

Image.propTypes = {
  src: PropTypes.string,
  onClick: PropTypes.any,
  id: PropTypes.string,
  className: PropTypes.string,
  role: PropTypes.string,
  alt: PropTypes.string,
  defaultImgSrc: PropTypes.any,
  onError: PropTypes.any,
  loading: PropTypes.string
};

export default Image;
